import { BOARDS_SERVICE } from "@/services/boards.service.js";

const state = {postBoardOutput: false, getBoardsOutput: {}, getBoardByIdOutput: {}, deleteBoardByIdOutput: false, putBoardOutput: false};

const actions = {
    //Service to create boards
    postBoard({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postBoardRequest');

        BOARDS_SERVICE.postBoard(input)
            .then(
                output => {
                    commit('postBoardSuccess', output);
                },
                error => {
                    commit('postBoardFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated boards
    getBoards({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getBoardsRequest');

        BOARDS_SERVICE.getBoards(queryParams)
            .then(
                output => {
                    commit('getBoardsSuccess', output);
                },
                error => {
                    commit('getBoardsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get board details
    getBoardById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getBoardByIdRequest');

        BOARDS_SERVICE.getBoardById(id)
            .then(
                output => {
                    commit('getBoardByIdSuccess', output);
                },
                error => {
                    commit('getBoardByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete boards
    deleteBoardById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteBoardByIdRequest');

        BOARDS_SERVICE.deleteBoardById(id)
            .then(
                output => {
                    commit('deleteBoardByIdSuccess', output);
                },
                error => {
                    commit('deleteBoardByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    updateBoard({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('updateBoardRequest');

        BOARDS_SERVICE.updateBoard(input)
            .then(
                output => {
                    commit('updateBoardSuccess', output);
                },
                error => {
                    commit('updateBoardFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    }
};

const mutations = {
    //postBoard
    postBoardRequest(state) {
        state.postBoardOutput = null;
    },
    postBoardSuccess(state, output) {
        state.postBoardOutput = true;
    },
    postBoardFailure(state) {
        state.postBoardOutput = false;
    },

    //getBoards
    getBoardsRequest(state) {
    },
    getBoardsSuccess(state, output) {
        state.getBoardsOutput = output;
    },
    getBoardsFailure(state) {
        state.getBoardsOutput = false;
    },

    //getBoardById
    getBoardByIdRequest(state) {
    },
    getBoardByIdSuccess(state, output) {
        state.getBoardByIdOutput = output;
    },
    getBoardByIdFailure(state) {
        state.getBoardByIdOutput = false;
    },

    //deleteBoardById
    deleteBoardByIdRequest(state) {
        state.deleteBoardByIdOutput = null;
    },
    deleteBoardByIdSuccess(state, output) {
        state.deleteBoardByIdOutput = true;
    },
    deleteBoardByIdFailure(state) {
        state.deleteBoardByIdOutput = false;
    },

    // putBoard
    updateBoardRequest(state) {
        state.putBoardOutput = null;
    },
    updateBoardSuccess(state, output) {
        state.putBoardOutput = true;
    },
    updateBoardFailure(state) {
        state.putBoardOutput = false;
    }
};

export const boards = {
    namespaced: true,
    state,
    actions,
    mutations
};